import { object, SchemaOf, string } from 'yup';

import { REQUIRED_FIELD } from '@/config/text.const';

export type Fields = {
  text: string;
};
//TODO: uncomment this code and code on line 18 when api part of emoji spike is ready, so this can be tested by QA guys
// const emojis_regex = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;

export const validationSchema: SchemaOf<Fields> = object().shape({
  text: string()
    .transform((value) => {
      return typeof value === 'string' ? value.trim() : value;
    })
    .min(1)
    .max(1000)
    //TODO: uncomment this code when api part of emoji spike is ready, so this can be tested by QA guys
    // .test((enteredValue, { createError }) => {
    //   const emojisCount = enteredValue?.match(emojis_regex)?.length;
    //   const charsCount = emojisCount ? enteredValue.length - emojisCount : enteredValue?.length;
    //   if (charsCount && charsCount > 1000) {
    //     return createError({
    //       message: 'Text must be at most 1000 characters'
    //     });
    //   }
    //   return true;
    // })
    .required(REQUIRED_FIELD)
});
